/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_CalendarsInputs */

const es_chat_tool_detail_calendars = /** @type {(inputs: Chat_Tool_Detail_CalendarsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calendarios`)
};

const en_chat_tool_detail_calendars = /** @type {(inputs: Chat_Tool_Detail_CalendarsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calendars`)
};

/**
* | output |
* | --- |
* | "{count} calendars" |
*
* @param {Chat_Tool_Detail_CalendarsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_calendars = /** @type {((inputs: Chat_Tool_Detail_CalendarsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_CalendarsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_calendars(inputs)
	return en_chat_tool_detail_calendars(inputs)
});
export { chat_tool_detail_calendars as "chat.tool_detail.calendars" }